import { Component, Input, OnInit } from '@angular/core';
import { CommonDataService } from '../../../common/services/common-data.service';
import { GraphqlService } from '../../../common/services/graphql.service';

@Component({
  selector: 'app-help-goto',
  templateUrl: './help-goto.component.html',
  styleUrls: ['./help-goto.component.css']
})
export class HelpGotoComponent implements OnInit {

  constructor(public commonDataService: CommonDataService,
    private graphQlService: GraphqlService) {
  }
  goto_heading;
  goto_desc;
  goto_para1heading
  goto_para1body;
  goto_para2heading;
  goto_para2_body;
  // IsRightPanel:boolean;
  @Input() IsRightPanel:boolean=false;
  
  ngOnInit(): void {
    window.scrollTo(0, 0);
    // this.IsRightPanel=this.commonDataService.showRightPanel.getValue();
   
    this.commonDataService.showLoader.next(true);
    this.gethelpgotolabels();
  }
  gethelpgotolabels() {
    this.graphQlService.gethelpgotoLabels().subscribe(data => {
      if (data != "") {
        var labels = data.content.data.labels;
        labels = labels.filter(x => x.key.trim());
        this.goto_heading = labels.filter(x => x.key == "goto_heading").map(y => y.value);
        this.goto_desc = labels.filter(x => x.key == "goto_desc").map(y => y.value);
        this.goto_para1heading = labels.filter(x => x.key == "goto_para1heading").map(y => y.value);
        this.goto_para1body = labels.filter(x => x.key == "goto_para1body").map(y => y.value);
        this.goto_para2heading = labels.filter(x => x.key == "goto_para2heading").map(y => y.value);
        this.goto_para2_body = labels.filter(x => x.key == "goto_para2_body").map(y => y.value);
        this.commonDataService.showLoader.next(false);
      }
    }, err => {
      console.log(err);
      this.commonDataService.showLoader.next(false);
    });
  }
}
